export const ANNOTATION_ADDED = 'ANNOTATION_ADDED';
export const ANNOTATION_CLICKED = 'ANNOTATION_CLICKED';
export const ANNOTATION_UPDATED = 'ANNOTATION_UPDATED';
export const ANNOTATION_DELETED = 'ANNOTATION_DELETED';
export const ANNOTATION_MOUSE_OVER = 'ANNOTATION_MOUSE_OVER';
export const ANNOTATION_MOUSE_OUT = 'ANNOTATION_MOUSE_OUT';
export const ANNOTATION_SELECTED = 'ANNOTATION_SELECTED';
export const ANNOTATION_UNSELECTED = 'ANNOTATION_UNSELECTED';
export const ANNOTATION_MODE_STARTED = 'ANNOTATION_MODE_STARTED';
export const ANNOTATION_MODE_ENDED = 'ANNOTATION_MODE_ENDED';
export const ANNOTATION_COUNT = 'ANNOTATION_COUNT';
